var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQualityWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0951 40.4998V42.3038M34.872 40.4998V42.3038M23.0083 42.2502C23.6101 42.9408 24.4955 43.3779 25.4834 43.3779C26.4715 43.3779 27.3567 42.9408 27.9587 42.2502M41.6892 12.3174C41.6892 11.2732 40.8427 10.4268 39.7986 10.4268C38.7543 10.4268 37.9079 11.2733 37.9079 12.3174M54.8089 12.3174C54.8089 11.2732 55.6555 10.4268 56.6996 10.4268C57.7438 10.4268 58.5903 11.2733 58.5903 12.3174M46.2435 14.5274C46.7312 15.087 47.4485 15.4411 48.2491 15.4411C49.0496 15.4411 49.7671 15.087 50.2547 14.5274",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6408 3.00079C58.5029 0.77419 53.0046 0.893271 48.2491 4.58974C39.4778 -2.22761 28.1641 3.12206 27.5518 12.939C27.4157 15.1301 27.7925 17.1793 28.5559 19.0955H29.0624C33.7312 19.0955 37.5297 22.8938 37.5297 27.5626V31.1718H45.1969C47.5887 31.1718 49.5662 32.9418 49.8933 35.243C59.006 30.3582 69.5837 23.1944 68.9473 12.9389C68.763 9.98384 67.6074 7.43376 65.8442 5.49755",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6185 31.1718V27.5626C19.6185 26.302 20.644 25.2765 21.9045 25.2765H29.0624C30.323 25.2765 31.3485 26.302 31.3485 27.5626V31.1718H37.5296V27.5626C37.5296 22.8938 33.7311 19.0955 29.0623 19.0955H21.9044C17.2356 19.0955 13.4371 22.8938 13.4371 27.5626V31.1718H19.6185ZM12.5012 49.8484C10.8462 49.8484 9.50455 51.19 9.50455 52.845V56.8769C9.50455 58.5318 10.8462 59.8735 12.5012 59.8735C14.1561 59.8735 15.4978 58.5318 15.4978 56.8769V52.845C15.4978 51.19 14.1561 49.8484 12.5012 49.8484Z",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5929 54.9149H41.4624V56.8769C41.4624 58.5319 40.1208 59.8735 38.4658 59.8735C36.811 59.8735 35.4694 58.5319 35.4694 56.8769V54.9149H15.4978V56.8769C15.4978 58.5319 14.1561 59.8735 12.5013 59.8735C10.8463 59.8735 9.50469 58.5319 9.50469 56.8769V54.9149H8.37402C5.9459 54.9149 3.79367 53.7366 2.4556 51.9213V61.7906C2.4556 65.4808 5.44715 68.4723 9.13732 68.4723H41.8296C45.5198 68.4723 48.5114 65.4808 48.5114 61.7906V51.9213C47.1733 53.7366 45.0211 54.9149 42.5929 54.9149Z",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02539 43.2696V47.5662C1.02539 51.6249 4.31553 54.9149 8.37402 54.9149H9.50455V52.8451C9.50455 51.1901 10.8462 49.8486 12.5012 49.8486C14.156 49.8486 15.4976 51.1902 15.4976 52.8451V54.9149H35.4692V52.8451C35.4692 51.1901 36.8108 49.8486 38.4657 49.8486C40.1207 49.8486 41.4623 51.1902 41.4623 52.8451V54.9149H42.5928C46.6514 54.9149 49.9414 51.6247 49.9414 47.5662V35.9167C49.9414 33.2962 47.8171 31.1719 45.1966 31.1719H5.77022C3.14973 31.1719 1.02539 33.2962 1.02539 35.9167V39.168",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4658 49.8485C40.1208 49.8485 41.4624 51.1901 41.4624 52.8451V56.877C41.4624 58.5319 40.1208 59.8736 38.4658 59.8736C36.8108 59.8736 35.4692 58.5319 35.4692 56.877V52.8451C35.4694 51.1901 36.8108 49.8485 38.4658 49.8485Z",
    stroke: "#D96122",
    strokeWidth: 2.05078,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityWork);
export default __webpack_public_path__ + "static/media/quality-work.4641a6563581496a1b6e2a1543f93a1b.svg";
export { ForwardRef as ReactComponent };